import { BsArrowLeft, BsArrowRight } from 'react-icons/bs';
import { Checkbox, Loader, Space } from '@mantine/core';

import EDropzone from 'libs/ui/src/EDropZone/EDropzone';
import { EButton, ESectionDivider, ESelect, ETextInput, ENumberInput } from 'libs/ui';

import useAffiliateOnboardRequest from './Hooks/useAffiliateOnboardRequest';
import { EDialog } from 'libs/ui/src/Dialog/EDialog';
import { MdError } from 'react-icons/md';
import { FaSearch } from 'react-icons/fa';

interface IProps {
    onSave: () => void;
    onCancel: () => void;
};

export default function AffiliateOnboardRequest({
    onSave,
    onCancel
}: IProps) {

    const {
        COMPANY_TYPE,
        countryList,
        stateList,
        getStateListBasedOnCountry,
        formStep,
        setFormStep,
        isSavinngData,
        isAgreeWithTerm,
        setIsAgreeWithTerm,
        validations,
        affiliateForm,
        PANVerification,
        setPANVerification,
        verifyPAN,
        postNewAffiliate
    } = useAffiliateOnboardRequest({
        onSave,
        onCancel
    });

    const formValues = affiliateForm.getValues();

    // console.log("formValues: ", formValues);

    return (
        <form
            onSubmit={affiliateForm.onSubmit(() => {
                // console.log("Called!");
                postNewAffiliate();
            })}
        >
            <div className="grid grid-cols-3 gap-4 pb-0 min-h-screen">
                {
                    formStep === 1
                        ?
                        <>
                            <ETextInput
                                label="Company Name"
                                placeholder="Enter Name"
                                key={affiliateForm.key('companyName')}
                                {...affiliateForm.getInputProps('companyName')}
                            />
                            <ETextInput
                                label="Website"
                                placeholder="Enter Website Name"
                                key={affiliateForm.key('website')}
                                {...affiliateForm.getInputProps('website')}
                            />
                            <ETextInput
                                label="Address 1"
                                placeholder="Enter Address"
                                key={affiliateForm.key('firstAddress')}
                                {...affiliateForm.getInputProps('firstAddress')}
                            />
                            <ETextInput
                                label="Address 2"
                                placeholder="Enter Address"
                                key={affiliateForm.key('secondAddress')}
                                {...affiliateForm.getInputProps('secondAddress')}
                            />
                            <ESelect
                                searchable
                                label="Country"
                                placeholder="Enter Country"
                                data={countryList.map(each => ({ label: each.name, value: String(each.id) })) ?? []}
                                key={affiliateForm.key('countryId')}
                                {...affiliateForm.getInputProps('countryId')}
                                onChange={(e) => {
                                    if (e) {
                                        getStateListBasedOnCountry(+e)
                                    };
                                    affiliateForm.setFieldValue('countryId', e ?? "")
                                    affiliateForm.setFieldValue('stateId', null)
                                    affiliateForm.setFieldValue('city', '')
                                }}
                            />
                            <ESelect
                                searchable
                                label="State"
                                placeholder="Select"
                                data={stateList}
                                key={affiliateForm.key('stateId')}
                                {...affiliateForm.getInputProps('stateId')}
                                onChange={(e) => affiliateForm.setFieldValue('stateId', e ?? "")}
                            />
                            <ETextInput
                                label="City"
                                placeholder="Enter City"
                                key={affiliateForm.key('city')}
                                {...affiliateForm.getInputProps('city')}
                            />
                            <ENumberInput
                                label="Pin Code"
                                placeholder="Enter Pin Code"
                                key={affiliateForm.key('pinCode')}
                                {...affiliateForm.getInputProps('pinCode')}
                            />
                            <ESelect
                                label="Company Type"
                                placeholder="Enter Company Type"
                                data={COMPANY_TYPE.map(each => ({ label: each.replaceAll("_", " "), value: each }))}
                                key={affiliateForm.key('companyType')}
                                {...affiliateForm.getInputProps('companyType')}
                            />

                            <div></div>
                            <div className="col-span-3">
                                <ESectionDivider title="Basic Settings" />
                            </div>
                            <ESelect
                                label="Title"
                                placeholder="Enter Title"
                                data={[
                                    { label: "Mr", value: "MR" },
                                    { label: "Miss", value: "MISS" },
                                    { label: "Mrs", value: "MRS" }
                                ]}
                                key={affiliateForm.key('title')}
                                {...affiliateForm.getInputProps('title')}
                            />
                            <ETextInput
                                label="First Name"
                                placeholder="Enter First Name"
                                key={affiliateForm.key('firstName')}
                                {...affiliateForm.getInputProps('firstName')}
                            />
                            <ETextInput
                                label="Last Name"
                                placeholder="Enter Last Name"
                                key={affiliateForm.key('lastName')}
                                {...affiliateForm.getInputProps('lastName')}
                            />
                            <ETextInput
                                label="PAN Number"
                                placeholder="Verify your PAN information"
                                // descriptionProps={{ style: { fontSize: "12px" } }}
                                readOnly={PANVerification.isVerifying}
                                rightSection={
                                    !PANVerification.PAN
                                        ||
                                        PANVerification.PAN?.length !== 10
                                        ?
                                        <></>
                                        :
                                        PANVerification.isVerifying
                                            ?
                                            <Loader size={16} />
                                            :
                                            <span
                                                className="mr-6 text-sm text-custom-blue cursor-pointer"
                                                onClick={verifyPAN}
                                            >Verify</span>
                                    // <FaSearch
                                    //     className="text-custom-blue cursor-pointer"
                                    //     onClick={verifyPAN}
                                    // />
                                }
                                value={PANVerification.PAN ?? undefined}
                                onChange={(e) => setPANVerification({ ...PANVerification, PAN: e.target.value })}
                            // key={affiliateForm.key('panNumber')}
                            // {...affiliateForm.getInputProps('panNumber')}
                            />
                            <ETextInput
                                label="Aadhar Number"
                                placeholder="Enter Aadhar Number"
                                key={affiliateForm.key("aadhaarNumber")}
                                {...affiliateForm.getInputProps('aadhaarNumber')}
                            />
                            <ETextInput
                                label="TDS Exemption Number"
                                placeholder="Enter TDS Exemption Number"
                                key={affiliateForm.key('tdsExemptionNumber')}
                                {...affiliateForm.getInputProps('tdsExemptionNumber')}
                            />
                            <ENumberInput
                                label="TDS Exemption Limit"
                                placeholder="Enter TDS Exemption Limit"
                                key={affiliateForm.key('tdsExemptionLimit')}
                                {...affiliateForm.getInputProps('tdsExemptionLimit')}
                            />
                            <ETextInput
                                label="TDS Exemption Rate"
                                placeholder="Enter TDS Exemption Rate"
                                key={affiliateForm.key('tdsExemptionRate')}
                                {...affiliateForm.getInputProps('tdsExemptionRate')}
                            />
                            <ETextInput
                                label="TDS Exemption Code"
                                placeholder="Enter TDS Exemption Code"
                                key={affiliateForm.key('tdsExemptionCode')}
                                {...affiliateForm.getInputProps('tdsExemptionCode')}
                            />
                            <ETextInput
                                label="XL Code"
                                placeholder="Enter XL Code"
                                key={affiliateForm.key('xlCode')}
                                {...affiliateForm.getInputProps('xlCode')}
                            />
                            {/* <ENumberInput
                                label="Look to Book Ratio Search"
                                placeholder="Enter Look to Book Ratio Search"
                                key={affiliateForm.key('lookToBookRatioSearch')}
                                {...affiliateForm.getInputProps('lookToBookRatioSearch')}
                            />
                            <ENumberInput
                                label="Look to Book Ratio Book"
                                placeholder="Enter Look to Book Ratio Book"
                                key={affiliateForm.key('lookToBookRatioBook')}
                                {...affiliateForm.getInputProps('lookToBookRatioBook')}
                            /> */}
                            {/* <div></div> */}

                            <div></div>
                            <div className="col-span-3">
                                <ESectionDivider title="Contact Details" />
                            </div>
                            <ETextInput
                                label="Email"
                                placeholder="Enter Email"
                                key={affiliateForm.key('email')}
                                {...affiliateForm.getInputProps('email')}
                            />
                            <ETextInput
                                label="Contact Number"
                                placeholder="Enter Contact Number"
                                key={affiliateForm.key('contactNumber')}
                                {...affiliateForm.getInputProps('contactNumber')}
                            />
                            {/* <ETextInput
                                label="Mobile Number"
                                placeholder="Enter Mobile Number"
                                key={affiliateForm.key('mobileNumber')}
                                {...affiliateForm.getInputProps('mobileNumber')}
                              /> */}
                            <div></div>

                            {/* <div className="col-span-3 flex gap-8">
                                <Checkbox
                                    label="Is Logo Advice"
                                    key={affiliateForm.key('isLogoAdvice')}
                                    {...affiliateForm.getInputProps('isLogoAdvice', { type: 'checkbox' })}
                                />
                                <Checkbox
                                    label="Is Corporate"
                                    key={affiliateForm.key('isCorporate')}
                                    {...affiliateForm.getInputProps('isCorporate', { type: 'checkbox' })}
                                />
                                <Checkbox
                                    label="Is Supplier Promo Code"
                                    key={affiliateForm.key('isSupplierPromoCode')}
                                    {...affiliateForm.getInputProps('isSupplierPromoCode', { type: 'checkbox' })}
                                />
                                <Checkbox
                                    label="PLM Affiliation"
                                    key={affiliateForm.key('pmlAffiliate')}
                                    {...affiliateForm.getInputProps('pmlAffiliate', { type: 'checkbox' })}
                                />
                            </div> */}
                        </>
                        :
                        // DOCUMENT SECTION
                        <>
                            <div className="col-span-3">
                                <ESectionDivider title="Documents" />
                            </div>
                            <EDropzone
                                unsecure
                                // required
                                accept="application/pdf"
                                label="Aadhar Card"
                                helperText="Please upload masked Aadhar card"
                                placeholder="Upload Masked Aadhar Card"
                                key={affiliateForm.key('aadhaarCardId')}
                                filesId={formValues.aadhaarCardId ? [formValues.aadhaarCardId] : []}
                                {...affiliateForm.getInputProps('aadhaarCardId')}
                                onChange={(value) => {
                                    console.log("value: ", value);
                                    affiliateForm.setFieldValue('aadhaarCardId', value[0]);
                                }}
                            />
                            <EDropzone
                                unsecure
                                // required
                                label="PAN Card ID"
                                placeholder="Upload PAN Card"
                                key={affiliateForm.key('panCardId')}
                                filesId={formValues.panCardId ? [formValues.panCardId] : []}
                                {...affiliateForm.getInputProps('panCardId')}
                                onChange={(value) => affiliateForm.setFieldValue('panCardId', value[0])}
                            />
                            <EDropzone
                                unsecure
                                // required={formValues.companyType?.toLocaleLowerCase() !== "individual"}
                                label="Company Registration"
                                placeholder="Upload Company Registration"
                                key={affiliateForm.key('companyRegistrationId')}
                                filesId={formValues.companyRegistrationId ? [formValues.companyRegistrationId] : []}
                                {...affiliateForm.getInputProps('companyRegistrationId')}
                                onChange={(value) => affiliateForm.setFieldValue('companyRegistrationId', value[0])}
                            />
                            <EDropzone
                                unsecure
                                label="GST ID"
                                key={affiliateForm.key('gstId')}
                                filesId={formValues.gstId ? [formValues.gstId] : []}
                                {...affiliateForm.getInputProps('gstId')}
                                onChange={(value) => affiliateForm.setFieldValue('gstId', value[0])}
                            />
                            <EDropzone
                                unsecure
                                label="Driving License"
                                key={affiliateForm.key('drivingLicenseId')}
                                filesId={formValues.drivingLicenseId ? [formValues.drivingLicenseId] : []}
                                {...affiliateForm.getInputProps('drivingLicenseId')}
                                onChange={(value) => affiliateForm.setFieldValue('drivingLicenseId', value[0])}
                            />
                            <div></div>
                            <ETextInput
                                label="GST Number"
                                placeholder="Enter GST Number"
                                key={affiliateForm.key('gstNumber')}
                                {...affiliateForm.getInputProps('gstNumber')}
                            />
                            <div></div>
                            <div></div>
                            {/* <div className="col-span-3">
                                <ESectionDivider title="Company Logo" />
                              </div> */}
                            <EDropzone
                                label="Company Logo ID"
                                key={affiliateForm.key('companyLogoId')}
                                filesId={formValues.companyLogoId ? [formValues.companyLogoId] : []}
                                {...affiliateForm.getInputProps('companyLogoId')}
                                onChange={(value) => affiliateForm.setFieldValue('companyLogoId', value[0])}
                            />

                        </>
                }
            </div>

            <Space h={"md"} />
            <Space h={"md"} />

            <div className="sticky bottom-0 flex justify-between items-center bg-neutral-50 border-t border-slate-500 py-4 px-10 ">
                {
                    formStep < 2
                        ?
                        <>
                            <div className=" flex gap-3 items-center justify-end w-full">
                                <EButton onClick={() => {
                                    affiliateForm.reset();
                                    onCancel();
                                }}
                                    variant="outline"
                                > Cancel </EButton>
                                <EButton
                                    rightSection={<BsArrowRight />}
                                    onClick={async () => {
                                        const valid = await affiliateForm.validate();

                                        if (valid.hasErrors) {
                                            EDialog({
                                                title: "Please fill all required fields",
                                                children: Object.values(valid.errors).map(e =>
                                                    <p className="flex gap-2 items-center"> <MdError color="red" /> {e}</p>
                                                ),
                                                withoutIcon: true
                                            })
                                        } else {
                                            setFormStep(formStep + 1);
                                        }
                                        // affiliateForm.validate() && setFormStep(formStep + 1)
                                    }}
                                >Next</EButton>
                            </div>
                        </>
                        :
                        <>
                            <Checkbox
                                label="I agree to the privacy policy and Terms & Conditions of PML Holidays."
                                checked={isAgreeWithTerm}
                                onChange={(e) => setIsAgreeWithTerm(e.currentTarget.checked)}
                            />
                            <div className=" flex gap-3 items-center justify-end">
                                <EButton variant="outline" leftSection={<BsArrowLeft />} onClick={() => setFormStep(formStep - 1)} > Back</EButton>
                                <EButton onClick={() => {
                                    affiliateForm.reset();
                                }}
                                    variant="outline"
                                > Cancel</EButton>
                                <EButton
                                    type="submit"
                                    loading={isSavinngData}
                                    disabled={!isAgreeWithTerm}
                                >Save</EButton>
                            </div>
                        </>
                }
            </div>
        </form>
    )
}
